import React from "react";

const Wedding3rd = () => {
  return (
    <div className="wedding3 overflow-hidden">
      <img
        className="page3_top"
        src="./Assets/wedding_page3_top.webp"
        alt="img"
      ></img>

      <img
        className="page3bottom"
        src="./Assets/wedding_page3_top.webp"
        alt="img"
      ></img>
      <div className="wedding3-container ">
        <div className="wedding3_img_container">
          <img
            className="wedding3_img"
            alt="img"
            src="./Assets/wedding_page3_img.webp"
          />
        </div>
        <div className="wedding_page3_text_container">
          <h1 className="wedding3_text_heading">Making Your Wedding </h1>
          <p className="wedding_page3_text">
            Lorem ipsum dolor sit amet consectetur. Adipiscing lectus sit sit
            sed semper vitae faucibus consequat. Sed dui auctor aliquam quam
            urna magna feugiat egestas placerat. Pharetra arcu nulla lacus
            molestie quis dignissim quis tempor interdum. Quam blandit iaculis
            ante pellentesque lectus viverra tristique ultrices. Adipiscing
            purus mattis leo sit mi id sed. Eleifend sed enim odio sapien
            tincidunt viverra. Interdum congue eu bibendum tellus odio.
            Ridiculus posuere ut id imperdiet lorem. Pellentesque turpis mi cras
            vel risus blandit elementum sed neque. Cursus mattis vulputate{" "}
          </p>
        </div>
      </div>

      <div>
        <img
          className="wedding-blur_circle1"
          src="./Assets/blur-circle.png"
          alt="blur"
        ></img>
      </div>

      <div>
        <img
          className="wedding-blur_circle2"
          src="./Assets/blur-circle.png"
          alt="blur"
        ></img>
      </div>
    </div>
  );
};

export default Wedding3rd;
